import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperOverviewPlazamapPage } from './shopper-overview-plazamap';

@NgModule({
  declarations: [
    ShopperOverviewPlazamapPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperOverviewPlazamapPage),
    TranslateModule.forChild()
  ],
})
export class ShopperOverviewPlazamapPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-overview-plazamap/shopper-overview-plazamap.module.ts